import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=967a4e64&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./minds.css?vue&type=style&index=0&lang=css&"
import style1 from "./Resources.vue?vue&type=style&index=1&id=967a4e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967a4e64",
  null
  
)

export default component.exports